import ApplicationModel, { attr } from '../ApplicationModel';
import { type AssistantPreviewContentAttributes } from './generated/AssistantPreviewContentAttributes';
import { model } from '../modelBuilder';

interface AssistantPreviewContent extends AssistantPreviewContentAttributes {}

@model
class AssistantPreviewContent extends ApplicationModel {
  // Start auto-generated
  static typename: 'AssistantPreviewContent' = 'AssistantPreviewContent';
  get typename(): 'AssistantPreviewContent' {
    return 'AssistantPreviewContent';
  }

  static fields = {
    autoCollapse: attr({ readable: true }),
    body: attr({ readable: true }),
    contentType: attr({ readable: true }),
    subtitle: attr({ readable: true }),
    title: attr({ readable: true }),
  };
  // End auto-generated
}

export default AssistantPreviewContent;
